import {PanelClientsEditMessages} from './panel-clients-edit.messages';

export const PanelClientsEditAssessmentMessages = {
    GetPortalsFailed: {
        key: 'GetPortalsFailed',
        message: 'Error while communication with the server. Request for getting assigned portals failed.'
    },
    GetPortalsInvalidData: {
        key: 'GetPortalsInvalidData',
        message: 'Information about assigned portals is not available.'
    },
    GetFinancialQuestionnaireTypesFailed: {
        key: 'GetFinancialQuestionnaireTypesFailed',
        message: 'Error while communication with the server. Request for getting questionnaire types failed.'
    },
    GetFinancialQuestionnairesAllFailed: {
        key: 'GetFinancialQuestionnairesAllFailed',
        message: 'Error while communication with the server. Request for getting financial questionnaire answers failed.'
    },
    GetFinancialQuestionnairesAllInvalidData: {
        key: 'GetFinancialQuestionnairesAllInvalidData',
        message: 'Information about financial questionnaire answers is not available.'
    },
    ...PanelClientsEditMessages
};
